<template>
  <div>
    <div v-if="isLoadingComponent && currentExpertise && currentExpertise.length > 0" class="wraper">
      <div data-v-296bad22="" class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
      </div>

      <div
        v-for="exp in currentExpertise[0].EXPERTISE_LIST"
        :key="exp.EXPERTISE_ID"
        class="container-fluid mycontainer-fluid content content_table"
      >
        <div class="container-stl" style="padding-top: 17px;">
          <div class="df-ac df-js-b stl-mb-20">
            <a href="#" class="header-link-back" @click.prevent="goBack" />
            <span
              class="c-i-icon c-i-delete c-i-delete-lg "
              v-if="exp.IS_VIEW_BUTTON_DELETE_EXPERTIZE == 1"
              @click="deleteExpertise(exp.EXPERTISE_ID)"
            />
          </div>
          <div class="row myrow grid-flex">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 mycol stl-df-fc">
              <div class="expert-chat-card-grid --jcfs">
                <div class="expert-chat-card-info">
                  <div
                    v-if="exp.MANAGER_CREATE_INFO.UF_MANAGER_GREATE_NAME !== ''"
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name"
                    >Экспертиза создана:</span
                    >
                    <strong>
                      {{ exp.MANAGER_CREATE_INFO.UF_MANAGER_GREATE_NAME }}
                      <template
                        v-if="exp.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME"
                      >
                        роль "{{
                          exp.MANAGER_CREATE_INFO.UF_GROUP_GREATE_NAME
                        }}"
                      </template>
                    </strong>
                  </div>
                  <div
                    v-if="
                      experts !== null &&
                        experts[currentExpertise[0].ID_TYPE_EXPERTISE]
                    "
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name">Эксперт:</span>
                    <strong>{{ exp.UF_EXPERT_NAME }}</strong>
                  </div>
                  <div
                    v-if="
                      experts !== null &&
                        experts[currentExpertise[0].ID_TYPE_EXPERTISE]
                    "
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name"
                    >Дата назначения эксперта:</span
                    >
                    <strong>{{
                        exp.UF_DATE_CREATE_EXPERT_TO_EXPERTISE
                      }}</strong>
                  </div>
                  <div
                    v-if="
                      experts !== null &&
                        experts[currentExpertise[0].ID_TYPE_EXPERTISE] &&
                        exp.IS_VIEW_DOP_EXPERT
                    "
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name"
                    >Дополнительный эксперт:</span
                    >
                    <strong>{{ exp.UF_EXPERT_DOP_NAME }}</strong>
                  </div>
                  <div
                    v-if="
                      experts !== null &&
                        experts[currentExpertise[0].ID_TYPE_EXPERTISE] &&
                        exp.IS_VIEW_DOP_EXPERT
                    "
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name"
                    >Дата назначения дополнительного эксперта:</span
                    >
                    <strong>{{
                        exp.UF_DATE_CREATE_EXPERT_TO_EXPERTISE_DOP
                      }}</strong>
                  </div>
                  <div class="expert-chat-card-info__row">
                    <span class="expert-chat-card-info__name">
                      {{
                        exp.IS_VIEW_DOP_EXPERT == 1
                          ? "Статус основной экспертизы"
                          : "Статус экспертизы"
                      }}:
                    </span>
                    <strong>
                      {{ getExpertiseStatusName(exp.UF_EXPERT_STATUS_ID) }}
                    </strong>

                    <a
                      @click="showStatusExpertise"
                      title="История изменения статуса"
                      class="icon-item status-history"
                    />
                  </div>
                  <div
                    v-if="
                      currentExpertise[0].IS_SET_VARIANT_DOP_EXPERTISE === 1 &&
                        currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                    "
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name"
                    >Вариант проведения экспертизы:</span
                    >
                    {{ getTypeZalogExpertis(exp.UF_VARIANT_DOP_EXPERTISE_ID) }}
                  </div>

                  <div class="expert-chat-card-info__row">
                    <span class="expert-chat-card-info__name"
                    >Дата начала экспертизы:</span
                    >
                    <strong>{{ exp.UF_DATE_START_EXPERT }}</strong>
                  </div>
                  <div
                    v-if="exp.UF_DATE_END_EXPERT"
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name">
                      {{
                        exp.IS_VIEW_DOP_EXPERT == 1
                          ? "Дата окончания основной экспертизы"
                          : "Дата окончания экспертизы"
                      }}:
                    </span>
                    <strong>{{ exp.UF_DATE_END_EXPERT }}</strong>
                  </div>
                  <div class="expert-chat-card-info__row df-js-b">
                    <span class="expert-chat-card-info__name"
                    >Тип экспертизы:</span
                    >
                    <div class="stl-w-290">
                      {{ currentExpertise[0].NAME_EXPERTISE }}
                    </div>
                  </div>
                  <div
                    class="expert-chat-card-info__row df-js-b"
                    v-if="
                      currentExpertise[0].IS_NEED_SET_SUBTYPE == 1 &&
                        exp.UF_SUPTYPE_EXPERTISE_ID > 0
                    "
                  >
                    <span class="expert-chat-card-info__name"
                    >Подтип экспертизы:</span
                    >
                    <div class="stl-w-290">
                      <template
                        v-for="spTime in currentExpertise[0].SUBTYPE_LIST_ALL"
                        v-if="spTime.ID == exp.UF_SUPTYPE_EXPERTISE_ID"
                      >
                        {{ spTime.UF_NAME }}
                      </template>
                    </div>
                  </div>

                  <div
                    v-if="
                      currentExpertise[0].IS_SET_RESULT_EXPERTISES &&
                        exp.IS_VIEW_RESULT_EXPERTISE == 1
                    "
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name">
                      {{
                        exp.IS_VIEW_DOP_EXPERT == 1
                          ? "Результат основной экспертизы"
                          : "Результат экспертизы"
                      }}:
                    </span>
                    <div class="stl-df-fc stl-w-290">
                      <select
                        :id="'expertise_' + exp.EXPERTISE_ID"
                        v-if="
                          exp.IS_SET_RESULT_EXPERTISE && exp.IS_MAIN_EXPERTISE
                        "
                        v-model="exp.UF_EXPERTISE_RESULT_ID"
                        class="expert-chat-card-select"
                        :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                        @change="
                          saveResultExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_EXPERTISE_RESULT_ID,
                            currentExpertise[0].RESULT_EXPERTISE_SP,
                            'expertise_' + exp.EXPERTISE_ID,
                            'UF_EXPERTISE_RESULT_ID'
                          )
                        "
                        :style="
                          'background:' +
                            getCSSResult(
                              currentExpertise[0].RESULT_EXPERTISE_SP,
                              exp.UF_EXPERTISE_RESULT_ID
                            )
                        "
                      >
                        <option
                          v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_SP"
                          v-if="
                            (exp.IS_SET_NEW_RESULT_BY_SC == 1 &&
                              expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION ===
                                1) ||
                              (exp.IS_SET_NEW_RESULT_BY_SC == 0 &&
                                expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION !==
                                  1)
                          "
                          :style="
                            `background-color: ${expertiseResult.UF_CSS_COLOR}`
                          "
                          :value="expertiseResult.ID"
                          :key="expertiseResult.ID"
                        >
                          {{ expertiseResult.UF_NAME }}
                        </option>
                      </select>
                      <template v-else-if="exp.UF_EXPERTISE_RESULT_ID">
                        <template
                          v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_SP"
                        >
                          <strong
                            v-if="
                              expertiseResult.ID === exp.UF_EXPERTISE_RESULT_ID
                            "
                            :style="
                              `background-color: ${expertiseResult.UF_CSS_COLOR}`
                            "
                          >
                            {{
                              getExpertiseResult(
                                exp.UF_EXPERTISE_RESULT_ID,
                                currentExpertise[0].RESULT_EXPERTISE_SP
                              )
                            }}
                          </strong>
                        </template>
                      </template>
                    </div>
                  </div>

                  <!-- результат экспертизы КИ -->
                  <template
                    v-if="
                      exp.IS_MAIN_EXPERTISE === 1 &&
                      exp.IS_VIEW_RESULT_EXPERTISE_KI === 1
                    "
                  >
                    <template v-if="exp.UF_VERSION_VIEW_KI == 1">
                      <div
                        class="expert-chat-card-info__row df-js-b"
                      >
                        <span class="expert-chat-card-info__name">Результат экспертизы КИ:</span>
                        <div class="stl-df-fc stl-w-290" style="min-width: 290px;">
                          <select
                            :id="'expertise_ki_' + exp.EXPERTISE_ID"
                            v-if="
                          exp.IS_SET_RESULT_EXPERTISE_KI
                        "
                            v-model="exp.UF_EXPERTISE_RESULT_KI_ID"
                            class="expert-chat-card-select"
                            :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                            @change="
                          saveResultExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_EXPERTISE_RESULT_KI_ID,
                            currentExpertise[0].RESULT_EXPERTISE_KI_SP,
                            'expertise_ki_' + exp.EXPERTISE_ID,
                            'UF_EXPERTISE_RESULT_KI_ID'
                          )
                        "
                            :style="
                          'background:' +
                            getCSSResult(
                              currentExpertise[0].RESULT_EXPERTISE_KI_SP,
                              exp.UF_EXPERTISE_RESULT_KI_ID
                            )
                        "
                          >
                            <option
                              v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_KI_SP"
                              :style="
                            `background-color: ${expertiseResult.UF_CSS_COLOR}`
                          "
                              :value="expertiseResult.ID"
                              :key="expertiseResult.ID"
                            >
                              {{ expertiseResult.UF_NAME }}
                            </option>
                          </select>
                          <template v-else-if="exp.UF_EXPERTISE_RESULT_KI_ID">
                            <template
                              v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_SP"
                            >
                              <strong
                                v-if="
                              expertiseResult.ID === exp.UF_EXPERTISE_RESULT_KI_ID
                            "
                                :style="
                              `background-color: ${expertiseResult.UF_CSS_COLOR}`
                            "
                              >
                                {{
                                  getExpertiseResult(
                                    exp.UF_EXPERTISE_RESULT_KI_ID,
                                    currentExpertise[0].RESULT_EXPERTISE_KI_SP
                                  )
                                }}
                              </strong>
                            </template>
                          </template>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="exp.UF_VERSION_VIEW_KI == 2">
                      <div class="expert-chat-card-info__row df-js-b"
                           v-for="(item, index) in exp.SETTING.listSubContractor"
                           v-if="exp.EXPERTISE_RESULT_KI_COAUTHOR[index] != undefined">
                        <span class="expert-chat-card-info__name"> Результат экспертизы КИ ({{ item.UF_NAME }}):</span>
                        <div class="stl-df-fc stl-w-290" style="min-width: 290px;">
                          <select
                            :id="'expertise_ki_' + item.ID + '_' +exp.EXPERTISE_ID"
                            v-if="exp.IS_SET_RESULT_EXPERTISE_KI"
                            v-model="exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID"
                            class="expert-chat-card-select"
                            :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                            @change="
                          saveResultExpertisesCoauthor(
                            exp.EXPERTISE_ID,
                            exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_COAUTHOR_ID,
                            exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID,
                            currentExpertise[0].RESULT_EXPERTISE_KI_SP,
                            'expertise_ki_'+ item.ID + '_' + exp.EXPERTISE_ID,
                            'UF_EXPERTISE_RESULT_KI_ID'
                          )
                        "
                            :style="
                          'background:' +
                            getCSSResult(
                              currentExpertise[0].RESULT_EXPERTISE_KI_SP,
                              exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID
                            )
                        "
                          >
                            <option
                              v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_KI_SP"
                              :style="
                            `background-color: ${expertiseResult.UF_CSS_COLOR}`
                          "
                              :value="expertiseResult.ID"
                              :key="expertiseResult.ID"
                            >
                              {{ expertiseResult.UF_NAME }}
                            </option>
                          </select>
                          <template v-else-if="exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID">
                            <template
                              v-for="expertiseResult in currentExpertise[0]
                                                      .RESULT_EXPERTISE_KI_SP"
                            >
                              <strong
                                v-if="
                                                        expertiseResult.ID === exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID
                                                      "
                                :style="
                                                        `background-color: ${expertiseResult.UF_CSS_COLOR}`
                                                      "
                              >
                                {{
                                  getExpertiseResult(
                                    exp.EXPERTISE_RESULT_KI_COAUTHOR[index].UF_EXPERTISE_RESULT_KI_ID,
                                    currentExpertise[0].RESULT_EXPERTISE_KI_SP
                                  )
                                }}
                              </strong>
                            </template>
                          </template>
                        </div>
                      </div>
                    </template>
                  </template>
                  <!-- результат экспертизы КИ end-->


                  <div
                    v-if="exp.IS_VIEW_NEED_CONSIDER"
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name"
                    >Необходимость корп. одобрения:</span
                    >
                    <div class="stl-df-fc stl-w-290">
                      <select
                        v-if="exp.IS_SET_NEED_CONSIDER"
                        class="expert-chat-card-select"
                        v-model="exp.UF_IS_NEED_CONSIDER_NS"
                        :id="'need_consider_' + exp.ID"
                        @change="
                          saveFinanceIRR(
                            exp.UF_IS_NEED_CONSIDER_NS,
                            exp.EXPERTISE_ID,
                            'UF_IS_NEED_CONSIDER_NS',
                            'Необходимость корп. одобрения'
                          )
                        "
                      >
                        <option value=""></option>
                        <option value="0">Нет</option>
                        <option value="1">Да</option>
                      </select>
                      <template v-else>
                        {{ exp.UF_IS_NEED_CONSIDER_NS == 1 ? "Да" : "Нет" }}
                      </template>
                    </div>
                  </div>
                  <div class="expert-chat-card-info__row df-js-b">
                    <span class="expert-chat-card-info__name"
                    >Назначена До/После Одобрения ЭС:</span
                    >
                    <div class="stl-w-290">
                      <select
                        :id="'expertise_set_time_' + exp.EXPERTISE_ID"
                        v-model="exp.UF_TIME_STATUS_CREATE_ID"
                        v-if="exp.IS_SET_TIME_CREATE_EXPERTISE"
                        class="form-control"
                        :disabled="false"
                        @change="
                          saveTimeStatusCreateExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_TIME_STATUS_CREATE_ID
                          )
                        "
                      >
                        <option
                          v-for="spTime in directory.sp_time_status_set_expertise"
                          v-if="spTime.CODE !== 'after_signing'"
                          :value="spTime.ID"
                          :key="spTime.ID"
                        >
                          {{ spTime.NAME }}
                        </option>
                      </select>
                      <template v-else-if="exp.UF_TIME_STATUS_CREATE_ID > 0">
                        <template
                          v-for="spTime in directory.sp_time_status_set_expertise"
                        >
                          <span
                            v-if="spTime.ID == exp.UF_TIME_STATUS_CREATE_ID"
                          >
                            {{ spTime.NAME }}
                          </span>
                        </template>
                      </template>
                    </div>
                  </div>

                  <template v-if="exp.IS_SET_FINANCIAL_IRR">
                    <div class="expert-chat-card-info__row df-js-b">
                      <span class="expert-chat-card-info__name"
                      >IRR, проценты:</span
                      >
                      <div class="stl-df-fc stl-w-290">
                        <vue-numeric
                          separator="space"
                          :precision="0"
                          :key="'irr_' + exp.ID"
                          type="text"
                          class="form-control i-wid-29"
                          :disabled="!exp.IS_VIEW_BUTTON_END"
                          v-model="exp.UF_IRR"
                          :max="100"
                          @change.native="
                            saveFinanceIRR(
                              exp.UF_IRR,
                              exp.EXPERTISE_ID,
                              'UF_IRR',
                              'IRR, проценты'
                            )
                          "
                        />
                      </div>
                    </div>
                    <div class="expert-chat-card-info__row df-js-b">
                      <span class="expert-chat-card-info__name"
                      >NPV, млн. рублей:</span
                      >
                      <div class="stl-df-fc stl-w-290">
                        <vue-numeric
                          separator="space"
                          :precision="0"
                          :key="'npv_' + exp.ID"
                          type="text"
                          class="form-control i-wid-29"
                          v-model="exp.UF_NPV"
                          :disabled="!exp.IS_VIEW_BUTTON_END"
                          @change.native="
                            saveFinanceIRR(
                              exp.UF_NPV,
                              exp.EXPERTISE_ID,
                              'UF_NPV',
                              'NPV, млн. рублей'
                            )
                          "
                        />
                      </div>
                    </div>
                    <div class="expert-chat-card-info__row df-js-b">
                      <span class="expert-chat-card-info__name"
                      >WACC, проценты:</span
                      >
                      <div class="stl-df-fc stl-w-290">
                        <vue-numeric
                          separator="space"
                          :precision="0"
                          :key="'npv_' + exp.ID"
                          type="text"
                          class="form-control i-wid-29"
                          v-model="exp.UF_WACC"
                          :max="100"
                          :disabled="!exp.IS_VIEW_BUTTON_END"
                          @change.native="
                            saveFinanceIRR(
                              exp.UF_WACC,
                              exp.EXPERTISE_ID,
                              'UF_WACC',
                              'WACC, проценты'
                            )
                          "
                        />
                      </div>
                    </div>
                    <div class="expert-chat-card-info__row df-js-b">
                      <span class="expert-chat-card-info__name"
                      >DPBP, лет:</span
                      >
                      <div class="stl-df-fc stl-w-290">
                        <vue-numeric
                          separator="space"
                          :precision="0"
                          :key="'npv_' + exp.ID"
                          type="text"
                          class="form-control i-wid-29"
                          v-model="exp.UF_DPBP"
                          :disabled="!exp.IS_VIEW_BUTTON_END"
                          @change.native="
                            saveFinanceIRR(
                              exp.UF_DPBP,
                              exp.EXPERTISE_ID,
                              'UF_DPBP',
                              'DPBP, лет'
                            )
                          "
                        />
                      </div>
                    </div>
                  </template>
                  <div
                    v-if="exp.IS_SET_TYPE_FIE_DZ && exp.IS_SET_TYPE_FIE_DZ == 1"
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name"
                    >Тип назначаемой экспертизы:</span
                    >
                    <div class="stl-df-fc stl-w-290">
                      <select
                        :id="'expertise_set_type_fie_' + exp.EXPERTISE_ID"
                        v-model="exp.UF_TYPE_FIE_ID"
                        v-if="exp.IS_SET_TYPE_FIE_DZ_EDIT"
                        class="form-control"
                        :disabled="
                          !exp.IS_SET_TYPE_FIE_DZ_EDIT ||
                            exp.UF_EXPERT_STATUS_ID != 131578
                        "
                        @change="
                          saveTypeFieExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_TYPE_FIE_ID
                          )
                        "
                      >
                        <option
                          v-for="spTime in directory.sp_expertise_type_fie"
                          v-if="
                            exp.CODE === 'pte' && spTime.CODE === 'lizing'
                              ? false
                              : true
                          "
                          :value="spTime.ID"
                          :key="spTime.ID"
                        >
                          {{ spTime.NAME }}
                        </option>
                      </select>
                      <template v-else>
                        <template
                          v-for="spTime in directory.sp_expertise_type_fie"
                        >
                          <span v-if="spTime.ID == exp.UF_TYPE_FIE_ID">
                            {{ spTime.NAME }}
                          </span>
                        </template>
                      </template>
                    </div>
                  </div>

                  <div
                    class="expert-chat-card-info__row df-js-b"
                    v-if="
                      exp.IS_SET_TYPE_FIE_DZ &&
                        exp.IS_SET_TYPE_FIE_DZ == 1 &&
                        isViewSconditionDZList.get(exp.EXPERTISE_ID)
                    "
                  >
                    <span class="expert-chat-card-info__name"
                    >Отлагательное условие:&nbsp;
                    </span>
                    <div class="stl-df-fc stl-w-290">
                      <Multiselect
                        label="UF_NAME_RECORD"
                        v-if="exp.IS_SET_TYPE_FIE_DZ_EDIT"
                        class="i-main-style-rp i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="exp.UF_SCONDITION_DZ_ID"
                        :options="currentExpertise[0].SCONDITION_LIST"
                        :multiple="false"
                        placeholder=""
                        @input="
                          saveExpertiseSconditionDZ(
                            exp.EXPERTISE_ID,
                            exp.UF_SCONDITION_DZ_ID
                          )
                        "
                        style="width: 98%; min-width: 150px; min-height: 36px; border: 1px solid #cecece"
                      />
                      <template v-else>
                        <template v-for="el in currentExpertise[0].SCONDITION_LIST">
                          <template v-for="el2 in exp.UF_SCONDITION_DZ_ID">
                            <span v-if="el.ID == el2.ID">
                              {{ el2.UF_NAME_RECORD }}
                            </span>
                          </template>
                        </template>
                      </template>
                    </div>
                  </div>

                  <div
                    v-if="exp.IS_VIEW_DOP_EXPERT"
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name"
                    >Результат дополнительной экспертизы:</span
                    >
                    <div class="stl-df-fc stl-w-290">
                      <select
                        :id="'expertise_dop_' + exp.EXPERTISE_ID"
                        v-if="
                          (exp.IS_VIEW_BUTTON_END ||
                            exp.IS_SET_RESULT_EXPERTISE) &&
                            exp.UF_EXPERT_STATUS_DOP_ID == 131578
                        "
                        v-model="exp.UF_EXPERTISE_RESULT_DOP_ID"
                        class="form-control"
                        :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                        @change="
                          saveResultExpertisesDop(
                            exp.EXPERTISE_ID,
                            exp.UF_EXPERTISE_RESULT_DOP_ID,
                            currentExpertise[0].RESULT_EXPERTISE_SP,
                            'expertise_dop_' + exp.EXPERTISE_ID
                          )
                        "
                        :style="
                          'background:' +
                            getCSSResult(
                              currentExpertise[0].RESULT_EXPERTISE_SP,
                              exp.UF_EXPERTISE_RESULT_DOP_ID
                            )
                        "
                      >
                        <option
                          v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_SP"
                          v-if="
                            (exp.IS_SET_NEW_RESULT_BY_SC == 1 &&
                              expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION ===
                                1) ||
                              (exp.IS_SET_NEW_RESULT_BY_SC == 0 &&
                                expertiseResult.UF_IS_ONLY_SUSPENSIVE_CONDITION !==
                                  1)
                          "
                          :style="
                            `background-color: ${expertiseResult.UF_CSS_COLOR}`
                          "
                          :value="expertiseResult.ID"
                          :key="expertiseResult.ID"
                        >
                          {{ expertiseResult.UF_NAME }}
                        </option>
                      </select>
                      <template v-else-if="exp.UF_EXPERTISE_RESULT_DOP_ID">
                        <template
                          v-for="expertiseResult in currentExpertise[0]
                            .RESULT_EXPERTISE_SP"
                        >
                          <strong
                            v-if="
                              expertiseResult.ID ===
                                exp.UF_EXPERTISE_RESULT_DOP_ID
                            "
                            :style="
                              `background-color: ${expertiseResult.UF_CSS_COLOR}`
                            "
                          >
                            {{
                              getExpertiseResult(
                                exp.UF_EXPERTISE_RESULT_DOP_ID,
                                currentExpertise[0].RESULT_EXPERTISE_SP
                              )
                            }}
                          </strong>
                        </template>
                      </template>
                    </div>
                  </div>
                  <div
                    v-if="currentExpertise[0].IS_SET_RISK_CLASS"
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name">Риск-класс:</span>
                    <div class="stl-df-fc stl-w-290">
                      <select
                        v-if="exp.IS_VIEW_BUTTON_END"
                        v-model="exp.UF_EXPERTISE_RISK_CLASS_ID"
                        class="form-control"
                        :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                        @change="
                          saveRiskClassExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_EXPERTISE_RISK_CLASS_ID
                          )
                        "
                      >
                        <option
                          v-for="expertiseRickClass in currentExpertise[0]
                            .RISK_CLASS_SP"
                          :value="expertiseRickClass.ID"
                          :key="expertiseRickClass.ID"
                        >
                          {{ expertiseRickClass.UF_NAME }}
                        </option>
                      </select>
                      <strong v-else-if="exp.UF_EXPERTISE_RISK_CLASS_ID">
                        {{
                          getRiskClassExpertises(
                            exp.UF_EXPERTISE_RISK_CLASS_ID,
                            currentExpertise[0].RISK_CLASS_SP
                          )
                        }}
                      </strong>
                    </div>
                  </div>
                  <div
                    v-if="currentExpertise[0].IS_SET_DURATION_EXPERTISE"
                    class="expert-chat-card-info__row df-js-b"
                  >
                    <span class="expert-chat-card-info__name"
                    >Вид проведения экспертизы:</span
                    >
                    <div class="stl-df-fc stl-w-290">
                      <template
                        v-if="
                          currentExpertise[0].IS_ONLY_SET_DIRECTOR &&
                            (isExpertiseEditable ||
                              currentUser.IS_EXPERT_DIRETOR === 1) &&
                            exp.IS_DIRECTOR_USER
                        "
                      >
                        <select
                          v-model="exp.UF_DURATION_EXPERTISE_ID"
                          class="form-control"
                          :disabled="
                            !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                          "
                        >
                          <option
                            v-for="durationExpertise in directory.sp_duration_expertise"
                            :value="durationExpertise.ID"
                            :key="durationExpertise.ID"
                          >
                            {{ durationExpertise.NAME }}
                          </option>
                        </select>
                        <button
                          v-if="currentExpertise[0].IS_ONLY_SET_DIRECTOR"
                          type="button"
                          @click="
                            saveDurationExpertise(
                              exp.EXPERTISE_ID,
                              exp.UF_DURATION_EXPERTISE_ID
                            )
                          "
                          class="btn btn-default"
                        >
                          Применить
                        </button>
                      </template>
                      <strong v-else>
                        {{ getDurationExpertise(exp.UF_DURATION_EXPERTISE_ID) }}
                      </strong>
                    </div>
                  </div>

                  <div
                    v-if="
                      exp.UF_DEMAND_URL && exp.UF_SOURCE_EXPERTISE_TYPE == 2
                    "
                    class="expert-chat-card-info__row"
                    style="padding: 10px 0;"
                  >
                    <a
                      :href="exp.UF_DEMAND_URL"
                      target="_blank"
                      class="btn btn-primary"
                    >
                      Открыть обращение в КЗ
                    </a>
                    <!--<a
                      :href="exp.UF_DEMAND_URL + '/downloadotherarchive'"
                      target="_blank"
                      class="btn btn-primary"
                      style="margin-left: 20px;"
                      >Скачать все документы по обращению
                    </a>-->
                  </div>

                  <div
                    v-if="currentExpertise[0].IS_SET_COMMENT"
                    class="expert-chat-card-info__row"
                  >
                    <span class="expert-chat-card-info__name">
                      {{
                        exp.IS_VIEW_DOP_EXPERT
                          ? "Комментарий основного эксперта"
                          : "Комментарий"
                      }}
                    </span>
                    <div class="stl-pt-10">
                      <textarea
                        v-if="exp.IS_SET_COMMENT && exp.IS_MAIN_EXPERTISE"
                        class="form-control stl-mb-10"
                        v-model="exp.UF_EXPERTISE_COMMENT"
                        style="resize: vertical; max-height: 600px;"
                        maxlength="5000"
                      />
                      <span class="input-description" style="margin-bottom: 5px" v-if="exp.IS_SET_COMMENT">
                        Доступно для ввода символов:
                        {{ countEnt(exp.UF_EXPERTISE_COMMENT, 5000) }}
                      </span>
                      <button
                        v-if="exp.IS_SET_COMMENT && exp.IS_MAIN_EXPERTISE"
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click="
                          saveCommentExpertises(
                            exp.EXPERTISE_ID,
                            exp.UF_EXPERTISE_COMMENT
                          )
                        "
                      >
                        Сохранить комментарий
                      </button>
                      <br />

                      <div v-if="!exp.IS_SET_COMMENT || !exp.IS_MAIN_EXPERTISE">
                        {{ exp.UF_EXPERTISE_COMMENT }}
                      </div>

                      <div
                        v-if="
                          exp.IS_SET_COMMENT &&
                            exp.IS_VIEW_DOP_EXPERT &&
                            exp.IS_SET_COMMENT_DOP
                        "
                      >
                        <span class="expert-chat-card-info__name">
                          <br />Комментарий дополнительного эксперта<br />
                        </span>
                        <textarea
                          v-if="
                            exp.IS_SET_COMMENT &&
                              exp.IS_VIEW_DOP_EXPERT &&
                              exp.IS_SET_COMMENT_DOP
                          "
                          class="form-control stl-mb-10"
                          v-model="exp.UF_EXPERTISE_COMMENT_DOP"
                        />
                        <button
                          v-if="
                            exp.IS_SET_COMMENT &&
                              exp.IS_VIEW_DOP_EXPERT &&
                              exp.IS_SET_COMMENT_DOP
                          "
                          type="button"
                          class="btn btn-primary"
                          data-dismiss="modal"
                          @click="
                            saveCommentExpertisesDop(
                              exp.EXPERTISE_ID,
                              exp.UF_EXPERTISE_COMMENT_DOP
                            )
                          "
                        >
                          Сохранить комментарий
                        </button>
                      </div>
                      <div
                        v-if="!exp.IS_SET_COMMENT || !exp.IS_SET_COMMENT_DOP"
                      >
                        {{ exp.UF_EXPERTISE_COMMENT_DOP }}
                      </div>
                    </div>
                    <div class="expert-chat-card-button-target" v-if="exp.IS_VIEW_BUTTON_DZ_TRANSH">
                      <router-link class="expert-chat-card-button-target__btn --orange" target="_blank" :to="{ name: 'AddDZ', params: {id:$route.params.id} }">Оформление ДЗ</router-link>
                      <a :href="currentExpertise[0].TRANSH_URL+'tranche-application/'+project.UF_NUMBER" class="expert-chat-card-button-target__btn --blue">Траншевое финансирование</a>
                    </div>
                  </div>
                </div>

                <div class="expert-chat-card-footer">
                  <div class="expert-chat-card-footer__row">
                    <div
                      v-if="exp.IS_VIEW_DOWNLOAD_AREA"
                      class="expert-chat-card-footer__item stl-w-full table-container-resize"
                    >
                      <!--                      <a href="#" class="c-link-blue" download="">-->
                      <!--                        <i class="d-i-icon d-i-xls"></i>-->
                      <!--                        Научно-техническая экспертиза.pdf-->
                      <!--                      </a>-->
                      <!--                    </div>-->
                      <!--                    <span class="expert-chat-card-footer__item">29.11.2018 14:42</span>-->
                      <!--                    <span class="expert-chat-card-footer__item">-->
                      <!--                                        <div class="c-i-icon c-i-etsp-none">-->
                      <!--                                            <span class="etsp-none-text">ЭЦП не прошла проверку</span>-->
                      <!--                                        </div>-->
                      <!--                                        <b class="stl-clr-blue">ЭЦП</b>-->
                      <!--                                        <span class="c-i-icon c-i-etsp"></span>-->
                      <!--                                    </span>-->
                      <!--                    <span class="expert-chat-card-footer__item">-->
                      <!--                                        <span class="c-i-icon c-i-etsp-info"></span>-->
                      <!--                                        <span class="stl-clr-blue">ecpinfo</span>-->
                      <!--                                    </span>-->
                      <table class="table expert-table-signatories">
                        <tbody>
                        <tr
                          :class="{
                              'document-file-delete':
                                exp.FILE_INFO['FILE'] !== null &&
                                exp.FILE_INFO['FILE']['UF_IS_DELETE'] == 1
                                  ? true
                                  : false
                            }"
                        >
                          <td
                            v-if="exp.IS_VIEW_DOWNLOAD_FILE_BUTTON"
                            class="expert-table-signatories--button"
                            style="width: 120px;"
                          >
                            <UploadExperFile
                              :exp="exp"
                              :docs="exp.FILE_INFO"
                              :sub-index="exp.FILE_INFO.TYPE_ID"
                            />
                            <div else></div>
                          </td>
                          <td>
                            <a
                              v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['FILE']
                                "
                              :href="exp.FILE_INFO['FILE']['FILE']"
                              target="_blank"
                              style="text-decoration: underline; color: #23527c"
                              class="doc-link"
                            >
                              {{ exp.FILE_INFO["NAME_TYPE"] }}
                            </a>
                            <span v-else>
                                <template
                                  v-if="exp.IS_DOWNLOAD_DOCUMENTS_NOT_REQ == 0"
                                >
                                  {{ exp.FILE_INFO["NAME_TYPE"] }}
                                </template>
                              </span>
                          </td>
                          <td>
                            <a
                              v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['COUNT_VERSION'] > 0
                                "
                              @click="
                                  getFileHistory(exp.FILE_INFO['FILE']['ID'])
                                "
                              style="display: inline-block; text-decoration: underline; color: #23527c"
                              class="doc-link"
                            >
                              {{ exp.FILE_INFO["FILE"]["COUNT_VERSION"] }}
                              (История)
                            </a>
                          </td>
                          <td>
                            <template
                              v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['UF_DATE_LOAD']
                                "
                            >
                              {{
                                exp.FILE_INFO["FILE"]["UF_DATE_UPDATE"]
                                  ? exp.FILE_INFO["FILE"]["UF_DATE_UPDATE"]
                                  : exp.FILE_INFO["FILE"]["UF_DATE_LOAD"]
                              }}
                            </template>
                          </td>

                          <!-- ЭЦП галочка-->
                          <td
                            v-if="
                                exp.FILE_INFO['FILE'] !== null &&
                                  exp.FILE_INFO['FILE']['IS_DOWNLOAD']
                              "
                            class="tc-main"
                          >
                            <div
                              class="doc-Y"
                              v-if="
                                  exp.FILE_INFO['FILE']['UF_IS_SIGN_ECP'] == 1
                                "
                            />
                            <div class="doc-N" v-else></div>
                          </td>
                          <td v-else></td>

                          <!-- ЭЦП Данные -->
                          <td style="white-space: nowrap;">
                            <div
                              class="esd-data"
                              v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD'] &&
                                    exp.FILE_INFO['IS_ECP_REQ']
                                "
                            >
                              <i
                                class="esd-data esd_icon"
                                @click="
                                    getECPInfo(exp.FILE_INFO['FILE']['ID'])
                                  "
                                style="margin-right: 25px"
                              >
                                ЭЦП
                                <img src="/images/i-eds.png" />
                              </i>
                              <div
                                class="esd-data__info esd-data__info-popup esd-data__info-popup--table"
                                v-show="
                                    resultECP[exp.FILE_INFO['FILE']['ID']]
                                  "
                              >
                                <div
                                  class="esd-close"
                                  @click="
                                      closeECP(exp.FILE_INFO['FILE']['ID'])
                                    "
                                >
                                  <i class="esd_exit"></i>
                                </div>
                                <div
                                  v-if="
                                      resultECP[exp.FILE_INFO['FILE']['ID']]
                                    "
                                >
                                  <p class="text-center">
                                    Подлинник электронного документа,
                                    подписанного ЭЦП,
                                    <br />хранится в информационной системе
                                    “Личный кабинет заемщика” <br />Фонда
                                    развития промышленности
                                  </p>
                                  <h3 class="esd-title">
                                    Сведения о сертификате ЭП
                                  </h3>
                                  <div class="container-fluid">
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Сертификат:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                                      >
                                        {{ result.SERTIFICATE_NUMBER }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Кем выдан:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.ISSUER }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Организация:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.COMPANY }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Кому выдан:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.OWNER_FIO }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Действителен:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.DATE_USE_SERTIFICATE }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Название документа:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.FILE_NAME }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xs-4 col-md-4 stl-col-pb-8"
                                      >
                                        Дата загрузки:
                                      </div>
                                      <div
                                        class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                      >
                                        {{ result.FILE_DATE_LOAD }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <!-- Подписант -->

                          <!-- Подписант -->
                          <td>
                            <template
                              v-if="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD']
                                "
                            >
                              <!--<a
                                v-for="item in exp.FILE_INFO[
                                  'ECP_GET_MANAGER_LIST'
                                ]"
                                v-if="
                                  item.ACTIVE_CODE ===
                                    currentUser.ACTIVE_ROLE_CODE
                                "
                                @click="
                                  getLinkFileECP(
                                    exp.FILE_INFO['FILE']['ID'],
                                    'txt'
                                  )
                                "
                              >
                                <img src="/images/ecp/txt.png" />
                              </a>-->

                              <a
                                v-for="item in exp.FILE_INFO[
                                    'ECP_GET_MANAGER_LIST'
                                  ]"
                                v-if="
                                    item.ACTIVE_CODE ===
                                      currentUser.ACTIVE_ROLE_CODE
                                  "
                                @click="
                                    getLinkFileECP(
                                      exp.FILE_INFO['FILE']['ID'],
                                      'sig'
                                    )
                                  "
                              >
                                <img src="/images/ecp/sig.png" />
                              </a>

                              {{
                                exp.FILE_INFO["FILE"]["UF_FILE_SIGN_AUTHOR"]
                              }}
                            </template>
                          </td>
                          <!-- Соответствие документа -->
                          <td v-if="exp.IS_VIEW_DOWNLOAD_FILE_BUTTON">
                            <a
                              v-show="
                                  exp.FILE_INFO['FILE'] !== null &&
                                    exp.FILE_INFO['FILE']['IS_DOWNLOAD'] &&
                                    exp.FILE_INFO['FILE']['UF_IS_AKCEPT'] !=
                                      1 &&
                                    exp.FILE_INFO['FILE']['UF_IS_DELETE'] != 1
                                "
                              @click="deleteFile(exp.FILE_INFO['FILE']['ID'])"
                              class="link-delete-row"
                              style="margin: 0 10px;"
                            />
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="expert-chat-card-footer__row">
                    <div
                      v-if="exp.IS_VIEW_BUTTON_END"
                      class="expert-chat-card-footer__row"
                    >
                      <button
                        v-if="exp.IS_NOT_SET_EXPERT == 1"
                        type="button"
                        @click="saveEndMainDocESExpertise(exp.EXPERTISE_ID)"
                        class="btn btn-default"
                      >
                        Завершить экспертизу
                      </button>
                      <button
                        v-else
                        type="button"
                        @click="saveEndMainDocESExpertise(exp.EXPERTISE_ID)"
                        :disabled="exp.UF_EXPERT_ID == 0 ? true : false"
                        class="btn btn-default"
                      >
                        Завершить экспертизу
                      </button>
                      <button
                        v-if="exp.IS_VIEW_BUTTON_END_DOP"
                        type="button"
                        @click="saveEndMainDocESExpertiseDop(exp.EXPERTISE_ID)"
                        class="btn btn-default"
                      >
                        Завершить дополнительную экспертизу
                      </button>
                    </div>
                  </div>
                  <div
                    class="expert-chat-card-footer__row stl-df-fc stl-df-al stl-row-gap--10"
                    v-if="
                      (exp.UF_EXPERT_ID !== 0 &&
                        showExpertSelector &&
                        currentUser.IS_EXPERT_DIRETOR === 1 &&
                        exp.IS_DIRECTOR_USER == 1) ||
                        (currentUser.IS_EXPERT_DIRETOR === 1 &&
                          exp.IS_DIRECTOR_USER == 1) ||
                        (exp.CODE == 'pte' &&
                          currentUser.ACTIVE_ROLE_CODE === 'admin')
                    "
                  >
                    <button
                      v-if="
                        exp.UF_EXPERT_STATUS_ID === 131578 &&
                          ((currentUser.IS_EXPERT_DIRETOR === 1 &&
                            exp.IS_DIRECTOR_USER == 1) ||
                            (exp.CODE == 'pte' &&
                              (currentUser.ACTIVE_ROLE_CODE === 'admin' ||
                                currentUser.ACTIVE_ROLE_CODE ===
                                  'manager3'))) &&
                          !exp.UF_DATE_END_EXPERT
                      "
                      type="button"
                      @click="expertHandler"
                      class="btn btn-primary"
                      style="margin-top: 20px"
                    >
                      {{
                        exp.UF_EXPERT_ID > 0
                          ? "Сменить ответственного"
                          : "Назначить ответственного"
                      }}
                    </button>

                    <div
                      class="expert-chat-card-info__name df-ac stl-w-full"
                      v-if="showExpertSelector"
                    >
                      <select
                        v-model="currentExpertise[0].NEW_EXPERT_ID"
                        class="form-control expert-chat-card-info__name"
                        style="height: 40px; max-width: 420px"
                        :disabled="
                          !currentExpertise[0].IS_ONLY_SET_DIRECTOR === 1
                        "
                      >
                        <option
                          v-for="expert in experts[
                            currentExpertise[0].ID_TYPE_EXPERTISE
                          ]"
                          :value="expert.ID"
                          :key="expert.ID"
                        >
                          {{ expert.NAME }}
                        </option>
                      </select>
                      <button
                        type="button"
                        @click="
                          addExpert(
                            currentExpertise[0].NEW_EXPERT_ID,
                            exp.EXPERTISE_ID
                          )
                        "
                        class="butt-stl butt-green"
                      >
                        {{
                          exp.UF_EXPERT_ID > 0
                            ? "Изменить эксперта"
                            : "Назначить эксперта"
                        }}
                      </button>
                    </div>
                  </div>
                  <div class="expert-chat-card-footer__row">
                    <div
                      v-if="exp.IS_MPT_EXPERTISE"
                      class="expert-chat-card-footer__row"
                    >
                      <div class="form-group">
                        <strong>Заключение Минпроторга</strong>
                        <label>
                          <input
                            type="checkbox"
                            v-model="exp.ZAKLUCHENIE_MPT.UF_IS_MPT"
                            :disabled="exp.ZAKLUCHENIE_MPT.UF_IS_MPT === 1"
                          />
                          Запрос направлен
                          {{ exp.ZAKLUCHENIE_MPT.UF_DATE_MPT }}
                        </label>
                        <div class="form-group">
                          <label>Департамент</label>
                          <select
                            class="form-control"
                            v-model="exp.ZAKLUCHENIE_MPT.UF_DEPARTAMENT_ID"
                            :disabled="
                              !exp.ZAKLUCHENIE_MPT.IS_CHANGE_DEPARTAMENT ||
                                !exp.IS_MPT_ZAKLUCHENIE_EDIT
                            "
                          >
                            <option
                              v-for="item in directory.departaments"
                              :value="item.ID"
                            >
                              {{ item.NAME }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Комментарий</label>
                          <textarea
                            v-model="exp.ZAKLUCHENIE_MPT.UF_COMMENT_MPT"
                            :disabled="!exp.IS_MPT_ZAKLUCHENIE_EDIT"
                            class="form-control"
                          />
                        </div>
                        <button
                          v-if="exp.IS_MPT_ZAKLUCHENIE_EDIT"
                          type="button"
                          @click="saveMPT(exp.ZAKLUCHENIE_MPT)"
                          class="btn btn-info"
                        >
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="expert-chat-card-footer__row">
                    <div class="expert-chat-card-footer__row">
                      <button
                        v-if="exp.IS_VIEW_BUTTON_SUSPEND == 1"
                        type="button"
                        @click="delayExpertiseOpenModal"
                        class="btn btn-danger expertise-action-btn"
                      >
                        Отложить экспертизу
                      </button>
                      <button
                        v-if="exp.IS_VIEW_BUTTON_BACK_TO_WORK == 1"
                        type="button"
                        @click="backToWork"
                        class="btn btn-info expertise-action-btn"
                      >
                        Вернуть в работу
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--    right side        -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7 mycol stl-df-fc">
              <div class="consultations-box">
                <div class="consultations-box__row">
                  <div class="consultations-h3-title stl-mb-30">
                    Переписка по экспертизе (Внутри ФРП)
                  </div>
                </div>
                <div class="consultations-chat-container">
                  <div class="consultations-chat-wrapper">
                    <div
                      class="consultations-chat__holder"
                      v-for="(item, index) in chatMessages"
                      :key="item.ID"
                    >
                      <div class="consultations-chat__holder-author">
                        <div class="consultations-chat__holder-author-name">
                          {{ item.AUTHOR.NAME }}
                        </div>
                        <div class="consultations-chat__holder-author-data">
                          {{ item.UF_DATE_CREATE }}
                        </div>
                      </div>
                      <!-- consultations-chat__holder-author -->
                      <div class="consultations-chat__holder-area">
                        <div class="consultations-chat__holder-content">
                          <div class="consultations-chat__holder-text">
                            <a
                              @click="editMessage(index)"
                              href="#editMess"
                              v-if="item.IS_EDIT_MESSAGE"
                              class="link-edit-row link-edit-chat js-edit-chat"
                            ></a>
                            <div v-html="item.UF_MESSAGE"></div>
                          </div>
                          <div
                            class="consultations-chat__holder-files"
                            v-if="item.FILES && item.FILES.length"
                          >
                            <b class="title">Файлы:</b>
                            <div class="consultations-chat__holder-files-area">
                              <span
                                class="consultations-chat__holder-files-area-item"
                                v-for="file in item.FILES"
                                :key="file.FILE_ID"
                              >
                                <a
                                  @click="openChatFileLink(file.FILE_ID)"
                                  class="consultations-box__doc-file"
                                  :class="chatFileIconClass(file)"
                                >{{ file.FILE_NAME }}</a
                                >
                              </span>
                            </div>
                            <br />
                          </div>
                        </div>
                        <a
                          @click="replyByUserMessage(item.AUTHOR)"
                          class="consultations-chat__reply"
                        >Ответить</a
                        >
                      </div>
                      <!-- consultations-chat__holder-area -->
                    </div>
                    <!-- consultations-chat__holder -->
                  </div>
                  <!-- consultations-chat-wrapper -->
                  <Pagination :pages="pages" :currentPage.sync="currentPage" />
                  <!-- consultations-chat-pagination -->
                </div>
                <!-- consultations-chat-container -->
                <a id="editMess"></a>
                <div class="consultations-chat-controll">
                  <div class="consultations-chat-controll__redactor">
                    <vue-editor
                      ref="editor"
                      v-model="editorData"
                      :editor-toolbar="toolbar"
                      :editorOptions="editorSettings"
                      @text-change="findCharEnter"
                    />
                  </div>
                  <div class="consultations-chat-controll__butt">
                    <div
                      v-if="file.name"
                      class="form-group"
                      v-for="(file, index) in fileList"
                    >
                      <div>
                        {{ file.name }} {{ file.size }}
                        <i
                          class="i-delete "
                          title="Удалить запись"
                          @click="deleteFileItem(index)"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="file-upload"
                      v-for="(file, index) in fileList"
                      v-show="file.showed"
                    >
                      <div class="file-upload">
                        <button type="button" class="btn btn-primary">
                          Загрузить документ
                        </button>
                        <input
                          v-show="file.showed"
                          type="file"
                          name="file"
                          ref="chatfile"
                          :index="index"
                          @change="changeChatFile"
                        />
                      </div>
                    </div>

                    <div style="display: inline-block">
                      <button
                        @click="sendMessage"
                        class="butt butt-green"
                        :class="{ disabled: editorData.length < 1 }"
                        :disabled="editorData.length > 3 ? false : true"
                      >
                        Отправить
                      </button>
                      <a @click="clearMessage" class="butt butt-gray">Отмена</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- consultations-box -->
              <!--              <div-->
              <!--                class="consultations-box consultations-box-documents"-->
              <!--                id="consultations-box-documents-r"-->
              <!--              >-->
              <!--                                <div class="consultations-box__row">-->
              <!--                                  <div class="consultations-h3-title">Вложенные файлы</div>-->
              <!--                                </div>-->
              <!--                                  <div-->
              <!--                                    class="consultations-box__doc-col"-->
              <!--                                    v-for="(file, index) in allListChatFiles"-->
              <!--                                  >-->
              <!--                                    <div class="stl-df-ac">-->
              <!--                                      <a-->
              <!--                                        @click="openFileLink(index)"-->
              <!--                                        class="consultations-box__doc-file "-->
              <!--                                        :class="{-->
              <!--                                          'doc-file-pdf':-->
              <!--                                            file.CONTENT_TYPE === 'application/pdf',-->
              <!--                                          'doc-file-xls':-->
              <!--                                            file.CONTENT_TYPE === 'application/vnd.ms-excel' ||-->
              <!--                                            file.CONTENT_TYPE ===-->
              <!--                                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',-->
              <!--                                          'doc-file-docs':-->
              <!--                                            file.CONTENT_TYPE === 'application/msword' ||-->
              <!--                                            file.CONTENT_TYPE ===-->
              <!--                                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'-->
              <!--                                        }"-->
              <!--                                        >{{ file.FILE_NAME }}</a-->
              <!--                                      >-->
              <!--                                    </div>-->
              <!--                                  </div>-->
              <!--              </div>-->
              <!-- consultations-box-documents-r -->
            </div>
          </div>

          <div
            class="modal fade in show"
            v-if="showDocHistoryDialog"
            tabindex="-1"
            role="dialog"
          >
            <div
              style="width: 1150px;z-index: 10000"
              class="modal-dialog"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    @click="showDocHistoryDialog = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    История изменения статуса документа
                  </h4>
                </div>
                <div
                  class="modal-body"
                  style="overflow: scroll; max-height: 800px;"
                >
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Версия документа</th>
                      <th>Документ</th>
                      <th>Дата загрузки документа</th>
                      <th></th>
                      <th>ЭЦП</th>
                      <th>Подписант</th>
                      <th>Дата действия</th>
                      <th>Сотрудник</th>
                      <th>Тип действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="item in documentHistory"
                      :class="{ 'document-file-delete': item.UF_IS_DELETE }"
                    >
                      <td>{{ item.VERSION }}</td>
                      <td>
                        <a
                          :href="siteUrl + item.FILE"
                          class="doc-link"
                          target="blank"
                        >{{ getFileName(item.FILE) }}</a
                        >
                      </td>
                      <td>{{ item.UF_DATE_UPDATE }}</td>
                      <!-- эцп -->
                      <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                        <div class="doc-Y" v-if="item.UF_IS_SIGN_ECP"></div>
                        <div class="doc-N" v-else></div>
                      </td>
                      <td v-else></td>
                      <!-- modal ECP -->
                      <td
                        style="white-space: nowrap; text-decoration-line: none !important"
                        v-if="item.IS_SET_ECP"
                      >
                        <i
                          class="esd-data esd_icon"
                          @click="getECPHistoryInfo(item.ID)"
                          style="margin-right: 25px"
                        >
                          ЭЦП
                          <img src="/images/i-eds.png" />
                        </i>
                        <div class="esd-data">
                          <div
                            class="esd-data__info_history"
                            v-show="resultECP[item.ID]"
                          >
                            <div class="esd-close" @click="closeECP(item.ID)">
                              <i class="esd_exit"></i>
                            </div>
                            <div v-if="resultECP[item.ID]">
                              <p class="text-center">
                                Подлинник электронного документа, подписанного
                                ЭЦП,
                                <br />хранится в информационной системе
                                “Личный кабинет заемщика” <br />Фонда развития
                                промышленности
                              </p>
                              <h3 class="esd-title">
                                Сведения о сертификате ЭП
                              </h3>
                              <div class="container-fluid">
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Сертификат:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                                  >
                                    {{ result[item.ID].SERTIFICATE_NUMBER }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Кем выдан:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].ISSUER }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Организация:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].COMPANY }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Кому выдан:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].OWNER_FIO }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Действителен:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].DATE_USE_SERTIFICATE }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Название документа:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].FILE_NAME }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                                    Дата загрузки:
                                  </div>
                                  <div
                                    class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn"
                                  >
                                    {{ result[item.ID].FILE_DATE_LOAD }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td style="white-space: nowrap;" v-if="item.IS_SET_ECP">
                        <div>
                          {{ item.UF_FILE_SIGN_AUTHOR }}
                        </div>
                      </td>
                      <td v-else></td>
                      <td>{{ item.UF_DATE_AKCEPT }}</td>
                      <td>{{ item.UF_MANAGER_AKCEPT_NAME }}</td>
                      <td>{{ item.UF_IS_AKCEPT }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    @click="showDocHistoryDialog = false"
                  >
                    Закрыть
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Отложить -->
          <div
            class="modal fade in show"
            v-if="isViewdelayModal"
            tabindex="-1"
            role="dialog"
          >
            <div class="modal-dialog modal-new-style" role="document">
              <div class="modal-content modal-content--resize">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    @click="isViewdelayModal = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    Отложить проведение экспертизы
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label>Комментарий<sup style="color:red">*</sup></label>
                    <textarea
                      class="form-control stl-w-full"
                      v-model="delayData.UF_COMMENT"
                    >
                    </textarea>
                  </div>
                  <div class="form-group delay-file-row">
                    <label class="delay-file-label">Файл</label>
                    <div class="file-upload delay-file-upload">
                      <button type="button" class="btn btn-primary">
                        Загрузить документ
                      </button>
                      <input
                        type="file"
                        name="delayFile"
                        ref="delayFile"
                        @change="changeDelayFile"
                      />
                    </div>
                    <div v-if="delayData.fileName" class="delay-file-name">
                      {{ delayData.fileName }}
                      <i
                        class="i-delete"
                        title="Удалить файл"
                        @click="removeDelayFile"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    class="butt-stl butt-black"
                    type="button"
                    @click="isViewdelayModal = false"
                  >
                    отменить
                  </button>
                  <button
                    class="butt-stl butt-blue"
                    type="button"
                    @click="delayExpertise"
                  >
                    Отложить
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- История изменения статуса -->
          <div
            class="modal fade in show"
            v-if="isShowStatusExpertiseDialog"
            tabindex="-1"
            role="dialog"
          >
            <form>
              <div
                class="modal-dialog modal-close-active modal-new-style"
                role="document"
              >
                <div
                  class="modal-content modal-content-middle modal-content-history"
                >
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      @click="isShowStatusExpertiseDialog = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      История изменений статуса экспертизы
                    </h4>
                    <div class="modal-suptitle"></div>
                  </div>
                  <div class="modal-body">
                    <div
                      class="modal-history-statys"
                      v-for="(item, index) in exp.HISTORY_STATUS_LIST"
                      :key="index"
                    >
                      <div class="modal-history-statys__name">
                        {{ item.UF_EXPERT_STATUS_NAME }}
                      </div>
                      <div class="modal-history-statys__author">
                        {{ item.UF_CREATED_BY_NAME }}
                        <span> {{ item.UF_DATE_CREATE }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-black"
                      @click="isShowStatusExpertiseDialog = false"
                    >
                      закрыть
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isLoadingComponent" class="container-fluid mycontainer-fluid" style="padding: 40px 30px;">
      <p>Данные экспертизы не найдены.</p>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import ProjectMenu from "@/components/project/partial/ProjectMenu.vue";
import ProjectHeader from "@/components/project/partial/ProjectHeader.vue";
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORIES,
  FETCH_EXPERTISE_DETAILS,
  FETCH_PROJECT
} from "@/store/actions.type";
import { ExpertiseService, ProjectsService } from "@/common/api.service";
import Vue from "vue";
import { AUTH_URL } from "@/common/config";
import UploadExperFile from "@/components/project/documents/UploadExperFile.vue";
import Multiselect from "vue-multiselect";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "ExpertiseDetails",
  components: {
    Pagination,
    Multiselect,
    ProjectHeader,
    ProjectMenu,
    UploadExperFile
  },
  data() {
    return {
      exp: null,
      isExpertiseEditable: false,
      resultECP: {},
      result: null,
      newExpertId: null,
      experts: null,
      isLoadingComponent: false,
      showDocHistoryDialog: false,
      documentHistory: [],
      siteUrl: "",
      showExpertSelector: false,
      editorId: 0,
      chatFile: { name: "" },
      fileList: [],
      toolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6]
          }
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: ""
          },
          {
            align: "center"
          },
          {
            align: "right"
          },
          {
            align: "justify"
          }
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered"
          },
          {
            list: "bullet"
          },
          {
            list: "check"
          }
        ],
        [
          {
            indent: "-1"
          },
          {
            indent: "+1"
          }
        ], // outdent/indent
        [
          {
            color: []
          },
          {
            background: []
          }
        ], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button
      ],
      editorSettings: {
        modules: {
          mention: {
            allowedChars: /^[A-Za-zА-Яа-я\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: this.chatUsers
          }
        }
      },
      selectedFiles: [],
      chatMessagesAll: [],
      chatMessages: [],
      allListChatFiles: [],
      adressatUserList: [],
      currentPage: 1,
      totalPages: 1,
      limit: 10,
      editorData: "",
      isViewSconditionDZList: [],
      isViewdelayModal: false,
      delayData: {
        UF_COMMENT: "",
        fileName: "",
        file: null
      },
      isShowStatusExpertiseDialog: false
    };
  },
  computed: {
    ...mapGetters(["directory", "currentUser", "currentExpertise", "project"]),
    listConfig() {
      const q = {
        id: this.$route.params.expertiseId,
        page: this.currentPage,
        limit: this.itemsPerPage
      };
      return q;
    },
    pages() {
      if (!this.totalPages || this.totalPages <= 5) {
        return [];
      }
      return [...Array(Math.ceil(this.chatMessagesAll.counts / 10)).keys()].map(
        e => e + 1
      );
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchChatMessages();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchChatMessages();
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "status_expertise",
      "sp_variant_zalog_expertise",
      "sp_duration_expertise",
      "departaments",
      "sp_time_status_set_expertise",
      "sp_expertise_type_fie"
    ]);
    await this.fetchExpertiseDetails();
  },
  mounted() {
    this.fetchChatMessages();
  },
  methods: {
    chatUsers(searchTerm, renderList, mentionChar) {
      let values = [];

      if (mentionChar === "@") {
        this.adressatUserList.forEach(function(v) {
          values.push({ id: v.ID, value: v.NAME });
        });
      }

      if (searchTerm.length === 0) {
        renderList(values, searchTerm);
      } else {
        const matches = [];
        for (let i = 0; i < values.length; i++)
          if (
            ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
          ) {
            matches.push(values[i]);
          }
        renderList(matches, searchTerm);
      }
    },
    editMessage(i) {
      this.editorId = this.chatMessages[i].ID;
      this.editorData = this.chatMessages[i].UF_MESSAGE;
    },
    async fetchChatMessages() {
      const { id, expertiseId } = this.$route.params;
      try {
        const { data } = await ExpertiseService.getListChatMessageExpertise(
          id,
          expertiseId,
          this.listConfig.limit,
          this.listConfig.page,
          ["date:desc"]
        );
        this.chatMessagesAll = data;
        this.chatMessages = data.items;
        this.totalPages = data.counts;
        this.allListChatFiles = data.allListChatFiles;
        this.adressatUserList = data.adressatUserList;
        this.fillFiles();
      } catch (error) {
        console.error("Error fetching chat messages:", error);
      }
    },
    async sendMessage() {
      const { id, expertiseId } = this.$route.params;
      const formData = new FormData();
      formData.append("message", this.editorData);
      if (this.$refs.chatfile && this.$refs.chatfile.length) {
        for (let v = 0; v < this.$refs.chatfile.length; v++) {
          if (this.$refs.chatfile[v] && this.$refs.chatfile[v].files) {
            for (let i = 0; i < this.$refs.chatfile[v].files.length; i++) {
              formData.append("UF_FILE_ID[]", this.$refs.chatfile[v].files[i]);
            }
          }
        }
      }

      console.log(this.editorId);

      try {
        if (!this.editorId) {
          await ExpertiseService.createChatMessageExpertises(
            id,
            expertiseId,
            formData
          );
        } else {
          await ExpertiseService.editChatMessageExpertises(
            id,
            expertiseId,
            this.editorId,
            formData
          );
        }

        this.editorData = "";
        this.selectedFiles = [];
        await this.fetchChatMessages();
        this.fillFiles();
      } catch (error) {
        console.error("Error sending message:", error);
      }
    },
    replyByUserMessage(author) {
      this.editorId = 0;
      this.$refs.editor["0"].quill
        .getModule("mention")
        .insertItem(
          { id: author.UF_AUTHOR_ID, value: author.NAME, denotationChar: "@" },
          true
        );
    },
    // иконка файла в переписке: сначала по расширению имени,
    // CONTENT_TYPE как запасной вариант (браузер часто шлёт octet-stream)
    chatFileIconClass(file) {
      const name = (file.FILE_NAME || "").toLowerCase();
      const ext = name.indexOf(".") !== -1 ? name.split(".").pop() : "";
      const type = (file.CONTENT_TYPE || "").toLowerCase();

      if (ext === "pdf" || type === "application/pdf") {
        return "doc-file-pdf";
      }
      if (
        ["doc", "docx", "rtf", "odt"].includes(ext) ||
        type.indexOf("word") !== -1
      ) {
        return "doc-file-docs";
      }
      if (
        ["xls", "xlsx", "xlsm", "csv", "ods"].includes(ext) ||
        type.indexOf("excel") !== -1 ||
        type.indexOf("spreadsheet") !== -1
      ) {
        return "doc-file-xls";
      }
      return "doc-file-def";
    },
    openChatFileLink(fileId) {
      const { id, expertiseId } = this.$route.params;
      return ExpertiseService.getLinkDownloadFileChatExpertise(
        id,
        expertiseId,
        fileId
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = ["кБ", "МБ", "ГБ", "TB", "PB", "EB", "ZB", "YB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
        );

      return bytes.toFixed(dp) + " " + units[u];
    },
    deleteFileItem(index) {
      this.fileList.splice(index, 1);
      this.fileList.push({
        isAdded: false,
        showed: false,
        name: ""
      });
      let sLast = true;
      this.fileList.forEach(v => {
        if (v.showed === true) {
          sLast = false;
        }
      });
      if (sLast) {
        this.fileList[this.fileList.length - 1].showed = true;
      }
    },
    changeChatFile(e) {
      let index = e.target.getAttribute("index");
      this.fileList[index].name = e.target.files[0].name;
      this.fileList[index].size = this.humanFileSize(e.target.files[0].size);
      this.fileList[index].showed = false;
      index++;
      if (this.fileList[index]) {
        this.fileList[index].showed = true;
      }
    },
    fillFiles() {
      this.fileList = [];
      for (let i = 0; i < 3; i++) {
        this.fileList.push({
          isAdded: false,
          showed: i === 0,
          name: ""
        });
      }
      if (this.$refs.chatfile && this.$refs.chatfile[0]) {
        this.$refs.chatfile[0].value = "";
      }
    },
    clearMessage() {
      this.editorData = "";
      this.editorId = 0;
      this.fillFiles();
    },
    delayExpertiseOpenModal() {
      this.delayData.UF_COMMENT = "";
      this.delayData.fileName = "";
      this.delayData.file = null;
      if (this.$refs.delayFile) {
        this.$refs.delayFile.value = "";
      }
      this.isViewdelayModal = true;
    },
    changeDelayFile(e) {
      if (e.target.files && e.target.files.length) {
        this.delayData.file = e.target.files[0];
        this.delayData.fileName = e.target.files[0].name;
      } else {
        this.delayData.file = null;
        this.delayData.fileName = "";
      }
    },
    removeDelayFile() {
      this.delayData.file = null;
      this.delayData.fileName = "";
      if (this.$refs.delayFile) {
        this.$refs.delayFile.value = "";
      }
    },
    findCharEnter() {
      this.editorData = this.editorData.replace(
        /@/g,
        this.replaceString(1, "Юзер")
      );
    },
    expertHandler() {
      this.showExpertSelector = !this.showExpertSelector;
    },
    async fetchExpertiseDetails() {
      const { id, expertiseId } = this.$route.params;
      await this.$store.dispatch(FETCH_PROJECT, id);
      await this.$store
        .dispatch(FETCH_EXPERTISE_DETAILS, { projectId: id, expertiseId })
        .then(async () => {
          if (this.experts === null) {
            this.experts = {};
            await Promise.all(
              Object.keys(this.currentExpertise).map(async e => {
                const experts = await this.expertList(
                  this.currentExpertise[e].ID_TYPE_EXPERTISE,
                  this.currentExpertise[e].VID_EXPERTISE
                );
                Vue.set(
                  this.experts,
                  this.currentExpertise[e].ID_TYPE_EXPERTISE,
                  experts
                );
              })
            );
          }

          this.isViewSconditionDZList = new Map();
          Object.keys(this.currentExpertise).map(function(e) {
            if (this.currentExpertise[e].IS_SET_TYPE_FIE_DZ == 1) {
              let idTemp = this.directory.sp_expertise_type_fie.filter(
                c => c.CODE == "suspensive_condition"
              );

              for (let key in this.currentExpertise[e].EXPERTISE_LIST) {
                let flag = false;
                if (
                  this.currentExpertise[e].EXPERTISE_LIST[key].UF_TYPE_FIE_ID ==
                  idTemp[0].ID
                ) {
                  flag = true;
                }
                this.isViewSconditionDZList.set(
                  this.currentExpertise[e].EXPERTISE_LIST[key].EXPERTISE_ID,
                  flag
                );
                Vue.set(
                  this.isViewSconditionDZList,
                  this.currentExpertise[e].EXPERTISE_LIST[key].EXPERTISE_ID,
                  flag
                );
              }
            }
          }, this);
          this.isLoadingComponent = true;
        });
    },
    expertList: async function(id, vidId) {
      return ExpertiseService.getListExpertMainDocESExpertise(
        id,
        vidId,
        this.project.ID
      ).then(({ data }) => data);
    },
    getExpertiseStatusName(id) {
      const status = this.directory.status_expertise.find(s => s.ID === id);
      return status ? status.NAME : "";
    },
    getTypeZalogExpertis: function(id) {
      let t = this.directory.sp_variant_zalog_expertise.filter(
        c => c.ID === id
      );
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getCSSResult(spResult, expertiseResultId) {
      //установить
      let t = spResult.find(c => c.ID === expertiseResultId);
      if (t != undefined && t.UF_CSS_COLOR !== "") {
        return t.UF_CSS_COLOR;
      }
      return "";
    },
    saveResultExpertises(idExpertise, expertiseResultId, spResult, id, fieldCode = "UF_EXPERTISE_RESULT_ID") {
      //установить
      let elem = document.getElementById(id);
      elem.style.background = this.getCSSResult(spResult, expertiseResultId);

      ExpertiseService.saveResultExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RESULT_ID: expertiseResultId,
          FIELD_CODE: fieldCode
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Результат экспертизы успешно изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertiseDetails();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveResultExpertisesCoauthor(idExpertise, idCoauthor, expertiseResultId, spResult, id) {
      //установить
      let elem = document.getElementById(id);
      elem.style.background = this.getCSSResult(spResult, expertiseResultId);

      ExpertiseService.saveResultExpertisesCoathor(
        this.$route.params.id,
        idExpertise,
        {
          UF_COAUTHOR_ID: idCoauthor,
          UF_EXPERTISE_RESULT_KI_ID: expertiseResultId,
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Результат экспертизы КИ успешно изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertiseDetails();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveFinanceIRR: function(val, expId, nameField, nameLabel) {
      ExpertiseService.editExpertiseField(
        this.$route.params.id,
        expId,
        nameField,
        {
          VALUE: val
        }
      ).then(({ data }) => {
        if (data.error) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show(
            "Запрос на изменение " + nameLabel + " успешно выполнен",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }
      });
    },
    saveTimeStatusCreateExpertises(idExpertise, expertiseSetTimeStatusId) {
      //установить
      ExpertiseService.saveTimeStatusCreateExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_TIME_STATUS_CREATE_ID: expertiseSetTimeStatusId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            "Поле \"Назначена До/После Одобрения ЭС\" успешно изменено",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertiseDetails();
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    getExpertiseResult(id, itemResultExpertises) {
      const result = itemResultExpertises.find(r => r.ID === id);
      return result ? result.UF_NAME : "";
    },
    saveTypeFieExpertises(idExpertise, expertiseTypeFieId) {
      //установить
      ExpertiseService.saveExpertiseTypeFIEDZ(
        this.$route.params.id,
        idExpertise,
        {
          UF_TYPE_FIE_ID: expertiseTypeFieId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            "Поле \"Тип назначаемой экспертизы\" успешно изменено",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertiseDetails();

          let idTemp = this.directory.sp_expertise_type_fie.filter(
            c => c.ID === expertiseTypeFieId && c.CODE == "suspensive_condition"
          );
          let flag = idTemp.length && idTemp[0].ID > 0 ? true : false;
          this.isViewSconditionDZList.set(idExpertise, flag);
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveResultExpertisesDop(idExpertise, expertiseResultId, spResult, id) {
      //установить
      let elem = document.getElementById(id);
      elem.style.background = this.getCSSResult(spResult, expertiseResultId);

      ExpertiseService.saveResultExpertisesDop(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RESULT_DOP_ID: expertiseResultId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            "Результат дополнительной экспертизы успешно изменен",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
          this.fetchExpertiseDetails();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    saveRiskClassExpertises(idExpertise, expertiseRickClassId) {
      ExpertiseService.saveRiskClassExpertises(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERTISE_RISK_CLASS_ID: expertiseRickClassId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertiseDetails();
        }
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
        this.$toasted.show("Риск-класс экспертизы успешно изменен", {
          theme: "green",
          position: "bottom-right",
          duration: 3000
        });
      }, this);
    },
    getRiskClassExpertises: function(id, itemRiskClassExpertises) {
      let t = itemRiskClassExpertises.find(c => c.ID === id);
      if (t.UF_NAME !== "") {
        return t.UF_NAME;
      }
      return "";
    },
    saveDurationExpertise(idExpertise, durationExpertiseId) {
      ExpertiseService.saveDurationExpertise(
        this.$route.params.id,
        idExpertise,
        {
          UF_DURATION_EXPERTISE_ID: durationExpertiseId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertiseDetails();
          this.$toasted.show("Вид проведения экспертизы изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    getDurationExpertise: function(id) {
      let t = this.directory.sp_duration_expertise.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    saveCommentExpertises(idExp, expertiseComment) {
      if (expertiseComment.length > 5000) {
        this.$toasted.show("Комментарий не может быть длиннее 5000 символов", {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });
        return;
      }
      ExpertiseService.saveCommentExpertises(this.$route.params.id, idExp, {
        UF_EXPERTISE_COMMENT: expertiseComment
      }).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Комментарий сохранен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveCommentExpertisesDop(idExp, expertiseComment) {
      ExpertiseService.saveCommentExpertisesDop(this.$route.params.id, idExp, {
        UF_EXPERTISE_COMMENT_DOP: expertiseComment
      }).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Комментарий сохранен", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    getFileHistory(id) {
      ProjectsService.getHistoryVersionDocument(this.$route.params.id, id).then(
        ({ data }) => {
          this.showDocHistoryDialog = true;
          this.documentHistory = data.FILE_VERSION_HISTORY;
        },
        this
      );
    },
    getECPHistoryInfo(idFile) {
      if (this.result[idFile] !== undefined) {
        Vue.set(this.resultECP, [idFile], true);
      } else {
        ProjectsService.getECPInfoHistoryFile(
          this.$route.params.id,
          idFile
        ).then(({ data }) => {
          Vue.set(this.result, [idFile], data.result);
          Vue.set(this.resultECP, [idFile], true);
        });
      }
    },
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    closeECP(id) {
      this.resultECP[id] = !this.resultECP[id];
    },
    getECPInfo(idFile) {
      Vue.set(this.resultECP, [idFile], true);
      ProjectsService.getECPInfoFile(this.$route.params.id, idFile).then(
        ({ data }) => {
          this.result = data.result;
          this.resultECP[idFile] = true;
        }
      );
    },
    getLinkFileECP(id, format) {
      ProjectsService.getLinkFileECP(this.$route.params.id, id, format).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    deleteFile(id) {
      ProjectsService.deleteDocument(this.$route.params.id, id).then(
        response => {
          if (response.data.result) {
            this.$toasted.show("Файл успешно удален", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
            this.fetchExpertiseDetails();
          } else {
            response.data.error.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        },
        this
      );
    },
    saveExpertiseSconditionDZ(idExpertise, expertiseSconditionDZId) {
      //установить
      ExpertiseService.saveExpertiseSconditionDZ(
        this.$route.params.id,
        idExpertise,
        {
          UF_SCONDITION_DZ_ID: expertiseSconditionDZId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Поле \"Отлагательное условие\" успешно изменено", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertise();
        }
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    goBack() {
      this.$router.push({
        name: "ExpertStatus",
        params: { id: this.$route.params.id }
      });
    },
    saveEndMainDocESExpertiseDop(id) {
      ExpertiseService.saveEndMainDocESExpertiseDop(
        this.$route.params.id,
        id
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Экспертиза завершена", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertiseDetails();
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    saveEndMainDocESExpertise(id) {
      ExpertiseService.saveEndMainDocESExpertise(
        this.$route.params.id,
        id
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show("Экспертиза завершена", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchExpertiseDetails();
        } else if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 8000
            });
          }, this);
        }
      }, this);
    },
    addExpert(expertId, idExpertise) {
      ExpertiseService.addMainDocESExpertiseExpert(
        this.$route.params.id,
        idExpertise,
        {
          UF_EXPERT_ID: expertId
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertiseDetails();
        }
      }, this);
      this.expertHandler();
    },
    saveMPT(zakluchenieMPT) {
      zakluchenieMPT.UF_IS_MPT = 1;
      ProjectsService.editZakluchenieMinPromByExpertise(
        this.$route.params.id,
        zakluchenieMPT
      ).then(({ data }) => {
        if (!data.error) {
          this.$toasted.show(
            "Информация о заключении  Минпроторга успешно сохранена",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            }
          );
          this.fetchExpertiseDetails();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    backToWork() {
      const { id, expertiseId } = this.$route.params;
      ExpertiseService.setBackToWorkExpertises(id, expertiseId)
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Экспертиза успешно возвращена в работу", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
            this.fetchExpertiseDetails();
          } else {
            data.errorArr.forEach(text => {
              this.$toasted.show(text, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            });
          }
        })
        .catch(error => {
          console.error("Ошибка при возврате экспертизы в работу:", error);
          this.$toasted.show(
            "Произошла ошибка при возврате экспертизы в работу",
            {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            }
          );
        });
    },
    delayExpertise() {
      const { id, expertiseId } = this.$route.params;
      const formData = new FormData();
      formData.append("UF_COMMENT", this.delayData.UF_COMMENT);
      if (this.delayData.file) {
        formData.append("UF_FILE_ID[]", this.delayData.file);
      }
      ExpertiseService.setSuspendExpertises(id, expertiseId, formData)
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Экспертиза успешно отложена", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
            this.delayData.UF_COMMENT = "";
            this.delayData.fileName = "";
            this.delayData.file = null;
            if (this.$refs.delayFile) {
              this.$refs.delayFile.value = "";
            }
            this.isViewdelayModal = false;
            this.fetchExpertiseDetails();
            this.fetchChatMessages();
          } else {
            data.errorArr.forEach(text => {
              this.$toasted.show(text, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            });
          }
        })
        .catch(error => {
          console.error("Ошибка при попытке отложить экспертизу:", error);
          this.$toasted.show(
            "Произошла ошибка при попытке отложить экспертизу",
            {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            }
          );
        });
    },
    getTimeStatusName(id) {
      const status = this.directory.sp_time_status_set_expertise.find(
        s => s.ID === id
      );
      return status ? status.NAME : "";
    },
    deleteExpertise(id) {
      if (confirm("Удалить экспертизу?")) {
        ExpertiseService.deleteMainDocESExpertise(
          this.$route.params.id,
          id
        ).then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Экспертиза удалена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.$router.push({
              name: "ExpertStatus",
              params: { id: this.$route.params.id }
            });
          } else if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        }, this);
      }
    },
    showStatusExpertise() {
      this.isShowStatusExpertiseDialog = true;
    },
    countEnt(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  }
};
</script>

<style scoped>
.delay-file-upload {
  position: relative;
  overflow: hidden;
  display: inline-block;
  line-height: 24px;
}

.delay-file-upload > button {
  outline: none;
}

.delay-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.delay-file-row {
  display: flex;
  align-items: center;
}

.delay-file-label {
  margin: 0 12px 0 0;
}

.delay-file-name {
  margin: 0 0 0 12px;
}

.expertise-action-btn {
  margin-bottom: 10px;
}
</style>
